import type { Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * Runtime config. Injected by the build via `window.APP_CONFIG` (see /public/config.js)
 * so we don't have to rebuild the SPA for each environment.
 */
declare global {
  interface Window {
    APP_CONFIG?: {
      apiBaseUrl?: string;
      aadClientId?: string;
      aadScope?: string;
      aadAuthority?: string;
    };
  }
}

const cfg = window.APP_CONFIG ?? {};

export const AAD_CLIENT_ID =
  cfg.aadClientId ?? '218fbb1a-052a-41a4-9911-ba662395cd05';

export const API_SCOPE =
  cfg.aadScope ?? `api://${AAD_CLIENT_ID}/Files.Upload`;

export const API_BASE_URL =
  cfg.apiBaseUrl ?? 'http://localhost:7071';

// Pin to the TSE tenant so MEG-Test (targetScope=MicrosoftIntegration) will
// issue tokens. `/common` routes to the user's home tenant (usually Corp),
// which triggers AADSTS500027 against a TSE app.
export const AAD_AUTHORITY =
  cfg.aadAuthority ??
  'https://login.microsoftonline.com/96368d8e-1f5a-4538-a075-592b2192a569';

/** MSAL config for a SPA using PKCE. Authority pinned to TSE tenant. */
export const msalConfig: Configuration = {
  auth: {
    clientId: AAD_CLIENT_ID,
    authority: AAD_AUTHORITY,
    redirectUri: `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

/**
 * Keep interactive sign-in limited to OIDC scopes. Requesting the custom API
 * scope here causes AADSTS65005 for Corp users even when a later silent token
 * request for the same scope succeeds.
 */
export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

/** Request the custom API scope only when the upload flow needs an API token. */
export const tokenRequest: RedirectRequest = {
  scopes: [API_SCOPE],
};
